import { useRequiredParams } from '@pba/react-router';
import { MemberCommunities, MemberCommunitiesHeader, MemberLayout } from 'features/users';
import { useGetPathToEntityDetail } from '../../hooks';

const PageMemberCommunities = () => {
  const { memberId } = useRequiredParams<{ memberId: string }>();
  const getPathToEntityDetail = useGetPathToEntityDetail();

  return (
    <MemberLayout header={(member) => <MemberCommunitiesHeader member={member} />} memberId={memberId}>
      {(member) => (
        <MemberCommunities
          getPathToCommunityDetail={(id) => getPathToEntityDetail(id, { entityType: 'community' })}
          member={member}
        />
      )}
    </MemberLayout>
  );
};

export default PageMemberCommunities;
